module.exports = __webpack_public_path__ + "img/966.95021a03.png";